import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import appUtil from '@/vue-dlb/utils/app-util'
import {UploadFile} from '@/vue-dlb/models'

import {  
  commitRetDataSets,
  showProgress
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet
} from "@/vue-dlb/utils/backend-util.js";

const state = {
  uploadingStatus: [],
  matchingStatus: []  
};

const getters = {
};

const actions = {
  queryUploadingStatus: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("uploadingStatus");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryUploadingStatus");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_DASHBOARD_LIST_UPLOADING_STATUS_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);    
    await api.putData("UserDispatcherServlet", reqdata).then(res => {      
      commitRetDataSets(commit, res.data);
    });
  },  
  queryMatchingStatus: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("matchingStatus");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryMatchingStatus");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_DASHBOARD_LIST_MATCHING_STATUS_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
}

const mutations = {
  uploadingStatus (state, datarows) {
    state.uploadingStatus = datarows;    
  },
  matchingStatus (state, datarows) {
    state.matchingStatus = datarows;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
